import { environment } from '../../../environments/environment.development';

export const PAYMENT_CONFIG: {
  checkout: {
    url: string;
    onSuccessTargetUrl: string;
  };
  billing: {
    customerPortalUrl: string;
  };
} = environment.payment;
